var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('CollectionsHero'),_c('CollectionsChat'),_c('CollectionsEngagement'),_c('AiChat'),_c('CollectionsCustomerPortals'),_c('CollectionsPaymentPortals'),_c('CollectionsCalendar'),_c('CollectionsLanguage'),_c('CollectionsSegments'),_c('RequestDemo',{attrs:{"msg":"Smarter collections, better outcomes."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }